import { all, takeEvery, put, fork } from 'redux-saga/effects';
import actions from './actions';
import { setToken, clearToken, getToken } from '@nal/helpers/utility';
import AuthHelper from '@nal/helpers/authHelper';

export function* loginSuccess() {
    yield takeEvery(actions.LOGIN_SUCCESS, function* ({ payload, history }: any) {
        yield setToken(payload.token);
        if (history) {
            history.push(payload?.back_url || '/');
        }
    });
}

export function* socialLoginSuccess() {
    yield takeEvery(actions.SOCIAL_LOGIN_SUCCESS, function* ({ payload, history }: any) {
        yield setToken(payload.token);
        if (history) {
            history.push(payload.url);
        }
    });
}

export function* logout() {
    yield takeEvery(actions.LOGOUT, function* ({ history }: any) {
        yield clearToken();
        history.push('/');
    });
}
export function* checkAuthorization() {
    yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {
        const { token } = AuthHelper.checkExpirity(getToken());
        if (token) {
            yield put({
                type: actions.LOGIN_SUCCESS,
                payload: { token },
                token,
                profile: 'Profile',
            });
        }
    });
}
export default function* rootSaga() {
    yield all([fork(checkAuthorization), fork(loginSuccess), fork(logout), fork(socialLoginSuccess)]);
}
